import { ref } from "vue";
import { defineStore } from "pinia";
import dayjs from "dayjs";

/**
 * 获取用户登录信息数据
 *
 * 用于动态存储全局变量
 *
 * 内置 userinfo 函数,用 userinfo.xxx 获取用户信息
 *
 * @example
 * const getlocaldata = localdata()
 * const userinfo = getlocaldata.userinfo
 * console.log(userinfo.用户ID)
 *
 * @returns {Object} 返回包含 userinfo 的 store 对象
 */
export const localdata = defineStore(
  "localdatainfo",
  () => {
    /**
     * 用户登录信息数据
     *
     * @type {import('vue').Ref<Object|null>}
     * @property {用户ID} 用户ID - 用户的唯一标识
     * @property {姓名} 姓名 - 用户姓名
     * @property {角色ID} 角色ID - 用户角色标识
     * @property {用户类型} 用户类型 - 0:管理员, 2:连锁管理员
     */
    const userinfo = ref(null); // 改为null而不是空字符串
    const myreimbnum = ref(null); //我的报销数量
    const mynotifynum = ref(null);  //我的抄送数量
    const system = ref(null); // 系统设置  
    const birthdayperson = ref(null); //生日人
    const expirytime = ref(null); //到期时间
    const showwindow = ref(false)   //是否已经显示过生日窗口
    //const YearMonth = ref(null); // 年月
    const doNotReminduserId = ref([]); // 是否不提醒用户生日
    const lastClearMonth = ref(null); // 上次清空的年月
    const shownotifywindow = ref(false);   //是否已经显示过通知窗口
    
    // 检查并清空doNotReminduserId（每月1号）
    const checkAndClearDoNotRemind = () => {
      const currentYearMonth = dayjs().format("YYYY-MM");
      const currentDay = dayjs().date();
      
      // 如果是每月1号，且上次清空的月份不是当前月份
      if (currentDay === 1 && lastClearMonth.value !== currentYearMonth) {
        doNotReminduserId.value = [];
        lastClearMonth.value = currentYearMonth;
        console.log(`已清空doNotReminduserId，当前月份：${currentYearMonth}`);
      }
      // 如果月份变了但不是1号，也要清空（防止跨月访问）
      else if (lastClearMonth.value && lastClearMonth.value !== currentYearMonth) {
        doNotReminduserId.value = [];
        lastClearMonth.value = currentYearMonth;
        console.log(`月份变更，已清空doNotReminduserId，当前月份：${currentYearMonth}`);
      }
      // 初始化lastClearMonth
      else if (!lastClearMonth.value) {
        lastClearMonth.value = currentYearMonth;
      }
    };
    //清空用户登录信息
    const clearUserInfo = () => {
      localStorage.removeItem("userinfo");
      localStorage.removeItem("password");
      localStorage.removeItem("userid");
      localStorage.removeItem("system");
      localStorage.removeItem("expirytime");
      userinfo.value = null;
    };

    const baoxiao = ref(null);
    function setbaoxiao(newbaoxiao) {
      localStorage.setItem("baoxiao", JSON.stringify(newbaoxiao));
      baoxiao.value = newbaoxiao;
    }

    /**
     * 移动端判断
     *
     * 通过窗口宽度和用户代理字符串判断是否为移动端设备
     *
     * @returns {boolean} 如果是移动端返回true，否则返回false
     */
    const isMobile = () => {
      if (window.innerWidth <= 768) return true;
      if (
        /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/.test(
          navigator.userAgent
        )
      )
        return true;
      return false;
    };

    return {
      userinfo,
      clearUserInfo,
      isMobile,
      myreimbnum,
      system,
      expirytime,
      setbaoxiao,
      baoxiao,
      birthdayperson,
      mynotifynum,
      showwindow,
      shownotifywindow,
      doNotReminduserId,
      lastClearMonth,
      checkAndClearDoNotRemind
    };
  },
  {
    persist: true,
  }
);
